import React, { useContext } from 'react';
import ContentToReviewTable from './ContentToReviewTable';
import { AppContext } from '../../contexts/AppContext';

const AuthorReviews = () => {
  const appContext = useContext(AppContext);
  // @ts-expect-error TS2339 - strict migration
  const { userProfile } = appContext.authnInfo;

  return (
    <ContentToReviewTable wrapperPadding={{ bottom: 'xxl', top: 'l' }} userProfile={userProfile} />
  );
};

export default AuthorReviews;
